import { SUPPORT_FEATURE } from "api/ApiPath";
import client from "api/client";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IOfficialDispatchRepository } from "features/officialDispatch/domain/repositories/IOfficialDispatchRepository";
import { injectable } from "tsyringe";
import { OfficialDispatchRequestModel } from "./model/OfficialDispatchRequestModel";
import { OfficialDispatchResponseModel } from "./model/OfficialDispatchResponseModel";

@injectable()
export class OfficialDispatchImpl implements IOfficialDispatchRepository {
  async getOfficialDispatches(
    params: OfficialDispatchRequestModel
  ): Promise<ListBaseApiResponseModel<OfficialDispatchResponseModel>> {
    return await client.get(SUPPORT_FEATURE.OFFICIAL_DISPATCH, params);
  }
}
